<template>
  <section>
    <div class="container">
      <section ref="chipsContainer" class="video-background" @wheel.passive="false" @wheel="onWheel">
        <!-- <video autoplay muted loop playsinline class="video-bg">
          <source src="@/assets/video.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video> -->
        <img src="@/assets/video.gif" alt="" class="video-bg"></img>
        <div class="content">
          <div class="content_nav">
            <div class="content_nav_error" :class="{ 'go-error': error }">
              <span>
                <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 52 52"
                  enable-background="new 0 0 52 52" xml:space="preserve">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M26,2C12.8,2,2,12.8,2,26s10.8,24,24,24s24-10.8,24-24S39.2,2,26,2z M8,26c0-9.9,8.1-18,18-18 c3.9,0,7.5,1.2,10.4,3.3L11.3,36.4C9.2,33.5,8,29.9,8,26z M26,44c-3.9,0-7.5-1.2-10.4-3.3c5.1-5.1,19.3-19.3,25.1-25.1 C42.8,18.5,44,22.1,44,26C44,35.9,35.9,44,26,44z">
                    </path>
                  </g>
                </svg>
              </span>
              <span>{{ ReturnText().erroreText }} </span>
            </div>
            <div class="content_nav_load" :class="{ 'go-load': load && !error }">
              <span><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17 10.25V15.5C17 16.6046 16.1046 17.5 15 17.5H3C1.89543 17.5 1 16.6046 1 15.5V10.25M8.99999 1.5V12.75M8.99999 1.5L13.5 6M8.99999 1.5L4.5 6"
                    stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg></span>
              <span>{{ ReturnText().Load }}</span>
            </div>
            <div class="content_nav_logo">
              <span>
                <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M23.1853 7.69625C23.1525 7.62219 22.3584 5.86062 20.5931 4.09531C18.2409 1.74312 15.27 0.5 12 0.5C8.72999 0.5 5.75905 1.74312 3.40687 4.09531C1.64155 5.86062 0.843741 7.625 0.814679 7.69625C0.772035 7.79217 0.75 7.89597 0.75 8.00094C0.75 8.10591 0.772035 8.20971 0.814679 8.30562C0.847491 8.37969 1.64155 10.1403 3.40687 11.9056C5.75905 14.2569 8.72999 15.5 12 15.5C15.27 15.5 18.2409 14.2569 20.5931 11.9056C22.3584 10.1403 23.1525 8.37969 23.1853 8.30562C23.2279 8.20971 23.25 8.10591 23.25 8.00094C23.25 7.89597 23.2279 7.79217 23.1853 7.69625ZM12 11.75C11.2583 11.75 10.5333 11.5301 9.9166 11.118C9.29992 10.706 8.81927 10.1203 8.53544 9.43506C8.25161 8.74984 8.17735 7.99584 8.32205 7.26841C8.46674 6.54098 8.82389 5.8728 9.34834 5.34835C9.87279 4.8239 10.541 4.46675 11.2684 4.32205C11.9958 4.17736 12.7498 4.25162 13.4351 4.53545C14.1203 4.81928 14.7059 5.29993 15.118 5.91661C15.5301 6.5333 15.75 7.25832 15.75 8C15.75 8.99456 15.3549 9.94839 14.6516 10.6517C13.9484 11.3549 12.9946 11.75 12 11.75Z"
                    fill="white" />
                </svg>
              </span>
              <span>{{ ReturnText().Lazarus }}</span>
            </div>
            <div class="content_nav_navigation">
              <ul>
                <!-- <li><a href="#">Главная</a></li> -->
                <li @click="scrollTo($refs.block2)"><a>{{ ReturnText().HowitWorks }}</a></li>
                <li @click="scrollTo($refs.block1)"><a>{{ ReturnText().WhyItsGreat }}</a></li>
                <li @click="scrollTo($refs.block3)"><a>{{ ReturnText().CaseStudies }}</a></li>
                <li @click="scrollTo($refs.block4)"><a>{{ ReturnText().FAQ }}</a></li>
                <li><a href="https://t.me/ailazarus" target="_blank">{{ ReturnText().TG }}</a></li>
              </ul>
            </div>
            <div class="content_nav_lang_block">
              <div @click="SvichLingRU()" class="content_nav_lang" :class="{ 'lang_absolune': lang == 'ru' }">
                <span>Ru</span>
                <!-- <span><svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.3332 1L7.94266 5.39052C7.42196 5.91122 6.57774 5.91122 6.05704 5.39053L1.6665 1" stroke="#9D9D9E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg> 
              </span>-->
              </div>
              <div @click="SvichLingEN()" class="content_nav_lang" :class="{ 'lang_absolune': lang == 'en' }">
                <span>En</span>
                <!--<span><svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.3332 1L7.94266 5.39052C7.42196 5.91122 6.57774 5.91122 6.05704 5.39053L1.6665 1" stroke="#9D9D9E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>-->
              </div>
            </div>
          </div>
          <br>
          <div class="modal-container" :class="{ 'modal-container_show': currentSlide == 1 }">
    <BaseModalV3 @set-langStop="langStop = $event" @set-load="load = $event" :Id=deviceId :text=lang @scroll-back="handleScrollBack"
        class="base_modal" :class="{ show_modal: currentSlide == 1 }" @upload-error="handleError"></BaseModalV3>
</div>
          <div class="content_footer" :class="{ 'slider-container_hidden': currentSlide == 1 && !isAnimating}">
            <div class="slider-container"
              :style="{ transform: `translateX(-${currentSlide * 100}%)` }, { width: `${SlideCount * 100}%` }">
              <div class="content_footer_screen screen1">
                <div class="content_footer_screen_block content_footer_screen_block_text">
                  <h1>{{ ReturnText().ImproveProcesses }}</h1>
                  <p>{{ ReturnText().AnalyzeDocs }}</p>
                </div>
                <div class="content_footer_screen_block content_footer_screen_block_content">
                  <div class="content_footer_screen_block_content_element">
                    <div class="content_footer_screen_block_content_element_img">
                      <img v-if="lang == 'ru'" src="./assets/img/QR.png" alt="">
                      <img v-if="lang == 'en'" src="./assets/img/QRen.png" alt="">
                    </div>
                    <a v-if="lang == 'ru'" target="_blank"
                      href="https://ai-lazarus.com/static/Lazarus_PresentationRU.pdf"
                      class="content_footer_screen_block_content_element_btn">
                      <p>
                        {{ ReturnText().WhyWeDoThis }}
                      </p>
                    </a>
                    <a v-if="lang == 'en'" target="_blank"
                      href="https://ai-lazarus.com/static/Lazarus_PresentationEN.pdf"
                      class="content_footer_screen_block_content_element_btn">
                      <p>
                        {{ ReturnText().WhyWeDoThis }}
                      </p>
                    </a>
                  </div>
                  <div class="content_footer_screen_block_content_element">
                    <div>
                      {{ ReturnText().UsefulFastFree }}
                    </div>
                    <div style="z-index: 4;" class="seve_btn" @click="nextSlide">
                      <span><svg width="18" height="19" viewBox="0 0 18 19" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M17 10.25V15.5C17 16.6046 16.1046 17.5 15 17.5H3C1.89543 17.5 1 16.6046 1 15.5V10.25M8.99999 1.5V12.75M8.99999 1.5L13.5 6M8.99999 1.5L4.5 6"
                            stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg></span>
                      <span>{{ ReturnText().UploadFile }}</span>
                    </div>
                  </div>
                  <div class="content_footer_screen_block_content_element">
                    <div class="info_block">
                      <div class="info_block_head">
                        AI
                      </div>
                      <div style="text-wrap: nowrap;" class="info_block_title">
                        {{ ReturnText().OpenAI2 }}
                      </div>
                      <div class="info_block_text">
                        {{ ReturnText().OpenAI3 }}
                      </div>
                    </div>
                    <div class="info_block">
                      <div class="info_block_title">
                        {{ ReturnText().Anonymous }}
                      </div>
                      <div class="info_block_text">
                        {{ ReturnText().Anonymous2 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content_footer_screen screen2">
                <!-- <div class="content_footer_screen_block content_footer_screen_block_text">
                  <h1>{{ ReturnText().UploadFilePrompt }}</h1>
                </div>
                <div class="content_footer_screen_block content_footer_screen_block_content">
                  <div class="add_btn"  @click="triggerFileInput">
                      <span><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 10.25V15.5C17 16.6046 16.1046 17.5 15 17.5H3C1.89543 17.5 1 16.6046 1 15.5V10.25M8.99999 1.5V12.75M8.99999 1.5L13.5 6M8.99999 1.5L4.5 6" stroke="#232329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
                      <span>{{ ReturnText().UploadFile }}</span>
                      <input
                          type="file"
                          ref="fileInput"
                          @change="handleFileUpload"
                          accept=".pdf,.doc,.docx,.txt"
                          style="display: none"
                        />
                    </div>
                </div> -->
              </div>
              <div class="content_footer_screen screen3">
                <div class="content_footer_screen_block content_footer_screen_block_text">
                  <h1>{{ ReturnText().Analyzing }}</h1>
                </div>
                <div class="content_footer_screen_block content_footer_screen_block_counter">
                  {{ count }}
                </div>
              </div>
              <div class="content_footer_screen screen2">
                <div class="content_footer_screen_block content_footer_screen_block_text">
                  <h1>{{ ReturnText().Great }}</h1>
                </div>
                <div class="content_footer_screen_block content_footer_screen_block_content finish_block">
                  <a :href="link" target="_blank" class="add_btn">
                    <span><svg width="18" height="19" viewBox="0 0 18 19" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M17 10.25V15.5C17 16.6046 16.1046 17.5 15 17.5H3C1.89543 17.5 1 16.6046 1 15.5V10.25M8.99999 1.5V12.75M8.99999 1.5L13.5 6M8.99999 1.5L4.5 6"
                          stroke="#232329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg></span>
                    <span>{{ ReturnText().Download }}</span>
                  </a>
                  <div class="add_btn restart_btn" @click="currentSlide = 1">
                    <span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M4.06189 13C4.02104 12.6724 4 12.3387 4 12C4 7.58172 7.58172 4 12 4C14.5006 4 16.7332 5.14727 18.2002 6.94416M19.9381 11C19.979 11.3276 20 11.6613 20 12C20 16.4183 16.4183 20 12 20C9.61061 20 7.46589 18.9525 6 17.2916M9 17H6V17.2916M18.2002 4V6.94416M18.2002 6.94416V6.99993L15.2002 7M6 20V17.2916"
                            stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                      </svg>
                    </span>
                    <span>{{ ReturnText().Repeat }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section ref="block1" class="block1">
        <h1>
          {{ ReturnText().FastAnalysis }}
        </h1>
        <div class="title">
          {{ ReturnText().FastAnalysis2 }}
        </div>
        <div class="block1_cards">
          <div class="block1_cards_card">
            <div class="block1_cards_card_head">
              {{ ReturnText().YouWillUpload }}
            </div>
            <div class="block1_cards_card_text">
              {{ ReturnText().SuitableDocs }}
            </div>
            <div class="block1_cards_card_footer card1">
              <div class="card1_btn">
                <div class="card1_btn_head">
                  {{ ReturnText().SampleDoc }}
                </div>
                <div class="card1_btn_text">
                  {{ ReturnText().SampleDoc2 }}
                </div>
              </div>
              <div class="card1_footer1">
              </div>
              <div class="card1_footer2">
              </div>
            </div>
          </div>
          <div class="block1_cards_card">
            <div class="block1_cards_card_head">
              {{ ReturnText().AIWillAnalyze }}
            </div>
            <div class="block1_cards_card_text">
              {{ ReturnText().SuitableDocs }}
            </div>
            <div class="block1_cards_card_footer card2">
              <img src="./assets/img/card2IMG.png" alt="">
            </div>
          </div>
          <div class="block1_cards_card">
            <div class="block1_cards_card_head">
              {{ ReturnText().WeWillSendReport }}
            </div>
            <div class="block1_cards_card_text">
              {{ ReturnText().ReportDetails }}
            </div>
            <div class="block1_cards_card_footer card3">
              <div class="logo">
                <span>
                  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M23.1853 7.69625C23.1525 7.62219 22.3584 5.86062 20.5931 4.09531C18.2409 1.74312 15.27 0.5 12 0.5C8.72999 0.5 5.75905 1.74312 3.40687 4.09531C1.64155 5.86062 0.843741 7.625 0.814679 7.69625C0.772035 7.79217 0.75 7.89597 0.75 8.00094C0.75 8.10591 0.772035 8.20971 0.814679 8.30562C0.847491 8.37969 1.64155 10.1403 3.40687 11.9056C5.75905 14.2569 8.72999 15.5 12 15.5C15.27 15.5 18.2409 14.2569 20.5931 11.9056C22.3584 10.1403 23.1525 8.37969 23.1853 8.30562C23.2279 8.20971 23.25 8.10591 23.25 8.00094C23.25 7.89597 23.2279 7.79217 23.1853 7.69625ZM12 11.75C11.2583 11.75 10.5333 11.5301 9.9166 11.118C9.29992 10.706 8.81927 10.1203 8.53544 9.43506C8.25161 8.74984 8.17735 7.99584 8.32205 7.26841C8.46674 6.54098 8.82389 5.8728 9.34834 5.34835C9.87279 4.8239 10.541 4.46675 11.2684 4.32205C11.9958 4.17736 12.7498 4.25162 13.4351 4.53545C14.1203 4.81928 14.7059 5.29993 15.118 5.91661C15.5301 6.5333 15.75 7.25832 15.75 8C15.75 8.99456 15.3549 9.94839 14.6516 10.6517C13.9484 11.3549 12.9946 11.75 12 11.75Z"
                      fill="white" />
                  </svg>
                </span>
                <span>{{ ReturnText().Lazarus }}</span>
              </div>
              <div class="card3_head">{{ ReturnText().LazarusReport }}</div>
              <div class="card3_text">
                {{ ReturnText().LazarusReport2 }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section ref="block2" class="block2">
        <div class="block2_text_content">
          <h1>
            {{ ReturnText().NoBiasAnalysis }}
          </h1>
          <div class="block2_text_content_text">
            {{ ReturnText().DeepAnalysis }}
          </div>
          <div class="block2_text_content_btn" @click="scrollTo($refs.chipsContainer)">
            <span>
              {{ ReturnText().TryProduct }}
            </span>
            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1.5L7.58578 8.08577C8.36683 8.86682 8.36684 10.1331 7.58579 10.9142L1 17.5" stroke="#1A79FF"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="block2_text_cards">
          <div class="block2_text_cards_card">
            <div class="block2_text_cards_card_icon">
              <svg width="44" height="39" viewBox="0 0 44 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M36.9681 4.59937C32.935 2.11687 27.625 0.75 22 0.75C16.375 0.75 11.065 2.11687 7.03187 4.59937C2.65937 7.29187 0.25 10.9875 0.25 15C0.25 19.0125 2.65937 22.7138 7.03187 25.4062C10.4969 27.5381 14.9069 28.845 19.6488 29.1712C19.2738 31.2469 17.9444 32.4994 16.795 33.21C14.2675 34.7681 10.6544 34.9313 8.00875 33.6038C7.7443 33.4713 7.45635 33.3922 7.16133 33.371C6.86632 33.3498 6.57002 33.3869 6.28936 33.4803C6.00869 33.5736 5.74916 33.7213 5.52557 33.9149C5.30198 34.1085 5.11872 34.3443 4.98625 34.6087C4.85378 34.8732 4.77469 35.1612 4.75351 35.4562C4.73232 35.7512 4.76945 36.0475 4.86277 36.3281C4.95609 36.6088 5.10378 36.8683 5.29741 37.0919C5.49103 37.3155 5.7268 37.4988 5.99125 37.6312C7.85865 38.5449 9.91236 39.0134 11.9913 39C14.5118 39.0178 16.9886 38.3412 19.15 37.0444C22.0469 35.2556 23.8375 32.4356 24.1806 29.1881C28.9806 28.8806 33.4562 27.5662 36.9606 25.41C41.3406 22.7175 43.75 19.0219 43.75 15C43.75 10.9781 41.3406 7.29187 36.9681 4.59937ZM11.7606 22.7869C12.1637 22.1704 12.7315 21.6792 13.3997 21.3693C14.0679 21.0594 14.8097 20.9432 15.5406 21.0337C17.4831 21.2944 18.6419 22.8019 19.2381 24.6206C16.6671 24.3952 14.1456 23.7787 11.7606 22.7925V22.7869ZM23.9237 24.6881C23.6029 23.007 22.914 21.4177 21.9062 20.0344C21.2254 19.1013 20.3643 18.3143 19.374 17.7198C18.3837 17.1253 17.2842 16.7354 16.1406 16.5731C12.7656 16.1213 9.66813 17.6775 7.87188 20.5106C5.9125 18.9375 4.75 17.0325 4.75 15C4.75 9.71437 12.6494 5.25 22 5.25C31.3506 5.25 39.25 9.71625 39.25 15C39.25 19.9237 32.4081 24.1331 23.9237 24.6937V24.6881Z"
                  fill="#FE83C3" />
              </svg>
            </div>
            <div class="block2_text_cards_card_text">
              <span class="block2_text_cards_card_text_head">
                {{ ReturnText().ObjectiveEvaluation }}
              </span>
              <span class="block2_text_cards_card_text_content">
                {{ ReturnText().ObjectiveEvaluation2 }}
              </span>
            </div>
          </div>
          <div class="block2_text_cards_card">
            <div class="block2_text_cards_card_icon">
              <svg width="36" height="45" viewBox="0 0 36 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 8.25C14.4399 8.25 10.9598 9.30568 7.99975 11.2835C5.03966 13.2614 2.73255 16.0726 1.37018 19.3617C0.00779915 22.6508 -0.348661 26.27 0.345873 29.7616C1.04041 33.2533 2.75474 36.4606 5.27209 38.9779C7.78943 41.4953 10.9967 43.2096 14.4884 43.9041C17.98 44.5987 21.5992 44.2422 24.8883 42.8798C28.1774 41.5175 30.9886 39.2104 32.9665 36.2503C34.9443 33.2902 36 29.8101 36 26.25C35.9946 21.4778 34.0964 16.9026 30.7219 13.5281C27.3474 10.1536 22.7722 8.25546 18 8.25ZM18 39.75C15.33 39.75 12.7199 38.9582 10.4998 37.4748C8.27975 35.9914 6.54942 33.883 5.52764 31.4162C4.50585 28.9494 4.23851 26.235 4.75941 23.6163C5.28031 20.9975 6.56606 18.5921 8.45407 16.7041C10.3421 14.8161 12.7475 13.5303 15.3663 13.0094C17.985 12.4885 20.6994 12.7558 23.1662 13.7776C25.633 14.7994 27.7415 16.5297 29.2249 18.7498C30.7083 20.9699 31.5 23.58 31.5 26.25C31.496 29.8292 30.0724 33.2607 27.5416 35.7916C25.0107 38.3224 21.5792 39.746 18 39.75ZM24.8419 18.6581C25.0516 18.8672 25.2181 19.1155 25.3316 19.389C25.4452 19.6625 25.5037 19.9557 25.5037 20.2519C25.5037 20.548 25.4452 20.8412 25.3316 21.1147C25.2181 21.3882 25.0516 21.6366 24.8419 21.8456L19.5919 27.0956C19.1692 27.5183 18.5959 27.7558 17.9981 27.7558C17.4004 27.7558 16.8271 27.5183 16.4044 27.0956C15.9817 26.6729 15.7442 26.0996 15.7442 25.5019C15.7442 24.9041 15.9817 24.3308 16.4044 23.9081L21.6544 18.6581C21.8634 18.4484 22.1118 18.2819 22.3853 18.1684C22.6588 18.0548 22.952 17.9964 23.2481 17.9964C23.5443 17.9964 23.8375 18.0548 24.111 18.1684C24.3845 18.2819 24.6329 18.4484 24.8419 18.6581ZM11.25 3C11.25 2.40326 11.4871 1.83097 11.909 1.40901C12.331 0.987053 12.9033 0.75 13.5 0.75H22.5C23.0967 0.75 23.669 0.987053 24.091 1.40901C24.513 1.83097 24.75 2.40326 24.75 3C24.75 3.59674 24.513 4.16903 24.091 4.59099C23.669 5.01295 23.0967 5.25 22.5 5.25H13.5C12.9033 5.25 12.331 5.01295 11.909 4.59099C11.4871 4.16903 11.25 3.59674 11.25 3Z"
                  fill="#837FFE" />
              </svg>
            </div>
            <div class="block2_text_cards_card_text">
              <span class="block2_text_cards_card_text_head">
                {{ ReturnText().TimeSaving }}
              </span>
              <span class="block2_text_cards_card_text_content">
                {{ ReturnText().TimeSaving2 }}
              </span>
            </div>
          </div>
          <div class="block2_text_cards_card">
            <div class="block2_text_cards_card_icon">
              <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M34 15H4C3.00544 15 2.05161 15.3951 1.34835 16.0984C0.645088 16.8016 0.25 17.7554 0.25 18.75V34.5C0.25 35.4946 0.645088 36.4484 1.34835 37.1516C2.05161 37.8549 3.00544 38.25 4 38.25H34C34.9946 38.25 35.9484 37.8549 36.6516 37.1516C37.3549 36.4484 37.75 35.4946 37.75 34.5V18.75C37.75 17.7554 37.3549 16.8016 36.6516 16.0984C35.9484 15.3951 34.9946 15 34 15ZM33.25 33.75H4.75V19.5H33.25V33.75ZM3.25 9.75C3.25 9.15326 3.48705 8.58097 3.90901 8.15901C4.33097 7.73705 4.90326 7.5 5.5 7.5H32.5C33.0967 7.5 33.669 7.73705 34.091 8.15901C34.5129 8.58097 34.75 9.15326 34.75 9.75C34.75 10.3467 34.5129 10.919 34.091 11.341C33.669 11.7629 33.0967 12 32.5 12H5.5C4.90326 12 4.33097 11.7629 3.90901 11.341C3.48705 10.919 3.25 10.3467 3.25 9.75ZM6.25 2.25C6.25 1.65326 6.48705 1.08097 6.90901 0.65901C7.33097 0.237053 7.90326 0 8.5 0H29.5C30.0967 8.89207e-09 30.669 0.237053 31.091 0.65901C31.5129 1.08097 31.75 1.65326 31.75 2.25C31.75 2.84674 31.5129 3.41903 31.091 3.84099C30.669 4.26295 30.0967 4.5 29.5 4.5H8.5C7.90326 4.5 7.33097 4.26295 6.90901 3.84099C6.48705 3.41903 6.25 2.84674 6.25 2.25Z"
                  fill="white" />
              </svg>

            </div>
            <div class="block2_text_cards_card_text">
              <span class="block2_text_cards_card_text_head">
                {{ ReturnText().DeepAnalytics }}
              </span>
              <span class="block2_text_cards_card_text_content">
                {{ ReturnText().DeepAnalytics2 }}
              </span>
            </div>
          </div>
        </div>
      </section>
      <section ref="block3" class="block3">
        <div>
          <img src="./assets/img/Frame 4.png" alt="">
        </div>
        <h1>
          {{ ReturnText().BigCompaniesUse }}
        </h1>
        <div class="block3_title">
          {{ ReturnText().ImprovingProcesses }}
        </div>
        <div class="block3_partners">
          <div class="block3_partners_head">
            <svg width="44" height="26" viewBox="0 0 44 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.97" clip-path="url(#clip0_1_734)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M40.4945 12.4551C35.4858 14.1898 31.5279 18.9704 30.5899 24.9417C30.5585 25.1458 30.72 25.3315 30.927 25.3315H34.936C36.3123 25.3315 37.5118 24.3963 37.8443 23.063L40.4933 12.4551H40.4945Z"
                  fill="#FD6D2A" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.6996 24.8573C15.6031 25.0801 15.7705 25.3319 16.0134 25.3319H24.3128C24.5604 25.3319 24.7755 25.1683 24.8463 24.9304C26.9491 17.8917 32.3297 12.2547 40.5756 10.5746C40.8221 10.5246 41.0208 10.3402 41.0824 10.0965L41.5555 8.21094C30.9709 8.71679 20.4142 13.9546 15.6996 24.8573Z"
                  fill="#FD6D2A" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M43.1914 1.62797L43.6052 0H8.27482C6.72534 0 5.37466 1.05476 5.00154 2.55625L3.49277 8.6307C3.38816 9.04961 3.80894 9.40114 4.20531 9.22595C14.6992 4.6066 28.1026 2.1803 42.5544 2.12344C42.8555 2.12228 43.1182 1.91922 43.1925 1.62797H43.1914Z"
                  fill="#FD6D2A" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1.29868 17.3806L-0.0101547 22.6648C-0.346082 24.0213 0.681459 25.3313 2.08096 25.3313H8.32058C8.60656 25.3313 8.86339 25.1677 8.98894 24.9113C14.2592 14.1583 25.1588 7.06623 41.5529 6.31664C41.8424 6.30388 42.0911 6.1043 42.1597 5.82349L42.5932 4.05859C25.2041 4.24657 12.3587 8.41691 2.0519 16.2295C1.67646 16.515 1.41143 16.9234 1.29868 17.3818V17.3806Z"
                  fill="#FD6D2A" />
              </g>
              <defs>
                <clipPath id="clip0_1_734">
                  <rect width="44" height="26" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span>{{ ReturnText().Avtodor }}</span>
          </div>
          <div class="block3_partners_content">
            <div class="block3_partners_content_head">
              {{ ReturnText().CaseStudyDetails }}
            </div>
            <div class="block3_partners_content_text">
              {{ ReturnText().CaseStudyDetails2 }}
            </div>
            <!-- <div class="block3_partners_content_btn">
              <span>Читать кейс</span>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 4.5L16.0858 11.0858C16.8668 11.8668 16.8668 13.1331 16.0858 13.9142L9.5 20.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            </div> -->
          </div>
          <div></div>
        </div>
      </section>
      <section ref="block4" class="block4">
        <h1>{{ ReturnText().IfQuestions }}</h1>
        <div>
          <div class="accordion">
            <div v-for="(item, index) in ReturnText().items" :key="index" class="accordion-item">
              <button @click="toggle(index)" class="accordion-header" :class="{ active: activeIndex !== index }">
                <span>{{ item.question }}</span>
                <svg :class="{ rotate: activeIndex !== index }" width="26" height="14" viewBox="0 0 26 14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.6668 2L14.8858 10.781C13.8444 11.8224 12.156 11.8224 11.1146 10.7811L2.3335 2"
                    stroke="#FFFFFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <div :class="{ hidden: activeIndex !== index }" class="accordion-content">
                <p>{{ item.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="block5">
        <div class="block5_head">
          <div class="block5_head_logo">
            <div class="logo">
              <span>
                <svg width="32" height="auto" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M23.1853 7.69625C23.1525 7.62219 22.3584 5.86062 20.5931 4.09531C18.2409 1.74312 15.27 0.5 12 0.5C8.72999 0.5 5.75905 1.74312 3.40687 4.09531C1.64155 5.86062 0.843741 7.625 0.814679 7.69625C0.772035 7.79217 0.75 7.89597 0.75 8.00094C0.75 8.10591 0.772035 8.20971 0.814679 8.30562C0.847491 8.37969 1.64155 10.1403 3.40687 11.9056C5.75905 14.2569 8.72999 15.5 12 15.5C15.27 15.5 18.2409 14.2569 20.5931 11.9056C22.3584 10.1403 23.1525 8.37969 23.1853 8.30562C23.2279 8.20971 23.25 8.10591 23.25 8.00094C23.25 7.89597 23.2279 7.79217 23.1853 7.69625ZM12 11.75C11.2583 11.75 10.5333 11.5301 9.9166 11.118C9.29992 10.706 8.81927 10.1203 8.53544 9.43506C8.25161 8.74984 8.17735 7.99584 8.32205 7.26841C8.46674 6.54098 8.82389 5.8728 9.34834 5.34835C9.87279 4.8239 10.541 4.46675 11.2684 4.32205C11.9958 4.17736 12.7498 4.25162 13.4351 4.53545C14.1203 4.81928 14.7059 5.29993 15.118 5.91661C15.5301 6.5333 15.75 7.25832 15.75 8C15.75 8.99456 15.3549 9.94839 14.6516 10.6517C13.9484 11.3549 12.9946 11.75 12 11.75Z"
                    fill="white" />
                </svg>
              </span>
              <span>{{ ReturnText().Lazarus }}</span>
            </div>
            <div>
              {{ ReturnText().Copyright }}
            </div>
          </div>
          <div @click="scrollTo($refs.chipsContainer)" class="block5_head_btn">
            {{ ReturnText().BackToTop }}
          </div>
        </div>
        <div class="block5_center">
          <div class="block5_center_text"> {{ ReturnText().ContactUs }}</div>
          <div class="block5_center_mail"> {{ ReturnText().ContactUs2 }}</div>
        </div>
        <div class="block5_footer">
          <div class="block5_footer_block block5_footer_left">
            <div class="block5_footer_block_adres">
              {{ ReturnText().Address }}
            </div>
          </div>
          <div class="block5_footer_block block5_footer_center">
            <a target="_blank" href="https://ai-lazarus.com/static/UserAgreementRU.pdf" v-if="lang == 'ru'"
              class="block5_footer_block_doc">{{ ReturnText().UserAgreement }}</a>
            <a target="_blank" href="https://ai-lazarus.com/static/UserAgreementEN.pdf" v-if="lang == 'en'"
              class="block5_footer_block_doc">{{ ReturnText().UserAgreement }}</a>
          </div>
          <div class="block5_footer_block block5_footer_right">
            <img v-if="lang == 'ru'" src="./assets/img/QR.png" alt="">
            <img v-if="lang == 'en'" src="./assets/img/QRen.png" alt="">
          </div>
        </div>
      </section>
    </div>
  </section>
</template>
<script>
import Conter from './components/ConterVue.vue';
import BaseModalV3 from './components/BaseModalV3.vue';
export default {
  components: {
    Conter,
    BaseModalV3
  },
  data() {
    return {
      showSlide: true,
      langStop: false,
      PageTextRu: {
        erroreText: 'Ошибка',
        Load: 'Загрузка...',
        Repeat: 'Повторить еще раз',
        Download: 'Скачать отчёт',
        Great: 'Все супер! Отчет готов, можно скачивать',
        Analyzing: 'Анализируем файл, пожалуйста подождите',
        Lazarus: 'Лазарус',
        Home: 'Главная',
        HowitWorks: 'Как работает',
        WhyItsGreat: 'Почему это круто',
        CaseStudies: 'Кейсы',
        FAQ: 'FAQ',
        TG: 'Telegram канал',
        En: 'En',
        UploadFilePrompt: 'Загрузите один файл с документацией в формате pdf, doc, docx или txt до 25 мб',
        UploadFile: 'Начать анализ',
        FastAnalysis: 'Быстрый и доступный анализ документации',
        FastAnalysis2: 'За 3 минуты проверим всё, что нужно',
        YouWillUpload: 'Вы загрузите файлы с документацией',
        SuitableDocs: 'Подойдут регламенты, отчёты, внутренние процедуры в формате pdf, docx или txt',
        SampleDoc: 'Регламент',
        SampleDoc2: 'о разработке должностных инструкций в АО «Свет»',
        AIWillAnalyze: 'AI проанализирует все данные',
        AnalysisDetails: 'Найдёт слабые места, подсветит важное и оценит эффективность',
        WeWillSendReport: 'Мы пришлём вам готовый отчёт',
        ReportDetails: 'Чёткий список проблем и решений с цифрами и аргументами.',
        LazarusReport: 'Лазарус. Отчёт о проекте',
        LazarusReport2: 'Сейчас расскажем как оптимизировать внутренние процессы',
        NoBiasAnalysis: 'Лазарус проводит анализ без субъективности и человеческого фактора.',
        NoBiasAnalysis2: 'Без переносов на завтра и предвзятого мнения',
        DeepAnalysis: 'А ещё может глубоко копать и подсказывать причины возникновения проблем, это экономит время и деньги',
        TryProduct: 'Попробовать продукт',
        ObjectiveEvaluation: 'Объективная оценка.',
        ObjectiveEvaluation2: 'Анализ без субъективности и человеческих ошибок.',
        TimeSaving: 'Экономия времени',
        TimeSaving2: 'AI проверяет за секунды то, что человек делал бы днями.',
        DeepAnalytics: 'Глубокая аналитика',
        DeepAnalytics2: 'Не просто выявляет проблемы, а объясняет их причины.',
        BigCompaniesUse: 'Крупные продукты уже используют Лазарус',
        ImprovingProcesses: 'И улучшают свои процессы с помощью искусственного интеллекта',
        Avtodor: 'Автодор',
        CaseStudyDetails: 'Уменьшили время на согласование процессов в госкомпании на 25%',
        CaseStudyDetails2: 'Анализ AI выявил несоответствия в документации и предложил оптимальные схемы.',
        ReadCase: 'Читать кейс',
        IfQuestions: 'Если остались вопросы',
        SupportedFormats: 'Какой формат файлов поддерживается?',
        WhatAIAnalyzes: 'Что анализирует AI?',
        WhatAIAnalyzes2: 'Регламенты, процессы, управление рисками, эффективность бизнес-процессов.',
        GetResultsFast: 'Как быстро я получу результат?',
        DataSecurity: 'Безопасны ли мои данные?',
        HowToUseReport: 'Как я могу использовать отчёт?',
        Copyright: '2025, Все права защищены',
        BackToTop: 'Вернуться наверх',
        ContactUs: 'Всегда рады знакомствам',
        ContactUs2: 'hi@ai-lazarus.com',
        Address: 'Москва, Страстной бульвар, 5',
        LegalDocs: 'Юридические документы',
        UserAgreement: 'Пользовательское соглашение',
        ImproveProcesses: 'Улучшим процессы внутри вашей компании за несколько минут',
        AnalyzeDocs: 'Посмотрим на вашу документацию и скажем, что можно улучшить',
        UsefulFastFree: 'Полезно, быстро и бесплатно',
        UploadFiles: 'Загрузить файлы',
        WhyWeDoThis: 'Рассказываем, зачем это делаем',
        OpenAI: 'Open AI',
        OpenAI2: 'На основе ИИ',
        OpenAI3: 'Используем сильный искусственный интеллект',
        Anonymous: 'Анонимно',
        Anonymous2: 'Не сохраняем никаких данных вашей компании',
        items: [
          { question: "Какой формат файлов поддерживается?", answer: "Мы поддерживаем форматы PDF, DOCX и TXT." },
          { question: "Что анализирует AI?", answer: "Регламенты, процессы, управление рисками, эффективность бизнес-процессов." },
          { question: "Как быстро я получу результат?", answer: "Результат будет готов в течение нескольких минут." },
          { question: "В безопасности ли мои данные?", answer: "Да, все данные защищены и хранятся в зашифрованном виде." },
          { question: "Как я могу использовать отчёт?", answer: "Вы можете скачать отчет в удобном формате и использовать для анализа." }
        ]
      },
      PageTextEn: {
        erroreText: 'Error',
        Load: 'Loading...',
        Repeat: 'Repeat again',
        Download: 'Download the report',
        Great: 'Everything is great! The report is ready, you can download it',
        Analyzing: 'Analyzing the file, please wait',
        Lazarus: 'Lazarus',
        Home: 'Home',
        HowitWorks: 'How it Works',
        WhyItsGreat: 'Why It’s Great',
        CaseStudies: 'Case Studies',
        FAQ: 'FAQ',
        TG: 'Telegram channel',
        En: 'En',
        UploadFilePrompt: 'Upload a single document file in PDF, DOC, DOCX or TXT format up to 25 MB',
        UploadFile: 'Start the analysis',
        FastAnalysis: 'Fast and Accessible Documentation Analysis',
        FastAnalysis2: 'In 3 minutes, we’ll check everything you need',
        YouWillUpload: 'You will upload documentation files',
        SuitableDocs: 'Regulations, reports, and internal procedures in PDF, DOCX or TXT formats will suffice',
        SampleDoc: 'Development',
        SampleDoc2: ' Instructions Regulations in “Svet” JSC',
        AIWillAnalyze: 'AI will analyze all the data',
        AnalysisDetails: 'It will identify weaknesses, highlight important aspects, and assess efficiency',
        WeWillSendReport: 'We will send you a ready report',
        ReportDetails: 'A clear list of issues and solutions with figures and arguments.',
        LazarusReport: 'Lazarus. Project Report',
        LazarusReport2: 'Let us show you how to optimize internal processes',
        NoBiasAnalysis: 'Lazarus conducts analysis without subjectivity and human error.',
        NoBiasAnalysis2: 'No postponements or biased opinions',
        DeepAnalysis: 'And it can dig deep and suggest reasons for problems, saving time and money',
        TryProduct: 'Try the Product',
        ObjectiveEvaluation: 'Objective Assessment.',
        ObjectiveEvaluation2: 'Analysis without subjectivity or human errors',
        TimeSaving: 'Time-saving',
        TimeSaving2: 'AI checks in seconds what would take a human days.',
        DeepAnalytics: 'Deep Analytics',
        DeepAnalytics2: 'Not only identifies problems but explains their causes.',
        BigCompaniesUse: 'Major products are already using Lazarus',
        ImprovingProcesses: 'And improving their processes with the help of artificial intelligence',
        Avtodor: 'Avtodor',
        CaseStudyDetails: 'Reduced process agreement time in a government company by 25%.',
        CaseStudyDetails2: 'AI analysis identified documentation discrepancies and suggested optimal schemes.',
        ReadCase: 'Read Case Study',
        IfQuestions: 'If you have questions',
        SupportedFormats: 'Which file formats are supported?',
        WhatAIAnalyzes: 'What does AI analyze?',
        WhatAIAnalyzes2: 'Regulations, processes, risk management, business process efficiency.',
        GetResultsFast: 'How quickly will I get the results?',
        DataSecurity: 'Is my data secure?',
        HowToUseReport: 'How can I use the report?',
        Copyright: '2025, All rights reserved',
        BackToTop: 'Back to Top',
        ContactUs: 'We are always glad to connect to you',
        ContactUs2: 'hi@ai-lazarus.com',
        Address: ' Moscow, Strastnoy Boulevard, 5',
        LegalDocs: 'Legal Documents',
        UserAgreement: 'User Agreement',
        ImproveProcesses: 'We will improve your company’s processes in a few minutes',
        AnalyzeDocs: 'We will look at your documentation and tell you what can be improved',
        UsefulFastFree: 'Useful, fast, and free',
        UploadFiles: 'Upload Files',
        WhyWeDoThis: 'Explaining why we do this',
        OpenAI: 'Open AI',
        OpenAI2: 'AI-Based',
        OpenAI3: 'We use powerful artificial intelligence tools',
        Anonymous: 'Anonymously',
        Anonymous2: 'We do not save any of your company’s data',
        items: [
          { question: "What file formats are supported?", answer: "We support PDF, DOCX, and TXT formats." },
          { question: "What does AI analyze?", answer: "Regulations, processes, risk management, and business process efficiency." },
          { question: "How quickly will I get the result?", answer: "The result will be ready within a few minutes." },
          { question: "Is my data safe?", answer: "Yes, all data is protected and stored in encrypted form." },
          { question: "How can I use the report?", answer: "You can download the report in a convenient format and use it for analysis." }
        ]
      },

      ApiLink: process.env.VUE_APP_API_ROOT,
       ApiLink:'',
      lang: 'ru',
      link: "",
      accordionColor: "#9D9D9E",
      currentSlide: 0,
      SlideCount: 4,
      count: 0,
      isAnimating: false,
      activeIndex: null,
      selectedFile: null,
      error: false,
      load: false,
      erroreText: 'Ошибка',
      deviceId: "",
      taskId: localStorage.getItem("task_id") || null,
      count: 0, // Текущий прогресс
      timer: 25000, // Длительность в мс
      intervalId: null, // ID setInterval
      decreaseInterval: null, // ID setInterval для уменьшения таймера
      startTime: null, // Время старта
      elapsedTime: 0, // Сколько уже прошло времени
      isRunning: false, // Флаг для отслеживания состояния таймера
      items: [
        { question: "Какой формат файлов поддерживается?", answer: "Мы поддерживаем форматы PDF, DOCX и TXT." },
        { question: "Что анализирует AI?", answer: "Регламенты, процессы, управление рисками, эффективность бизнес-процессов." },
        { question: "Как быстро я получу результат?", answer: "Результат будет готов в течение нескольких минут." },
        { question: "Безопасны ли мои данные?", answer: "Да, все данные защищены и хранятся в зашифрованном виде." },
        { question: "Как я могу использовать отчёт?", answer: "Вы можете скачать отчет в удобном формате и использовать для анализа." }
      ]
    }
  },
  created() {
    this.initializeDeviceId();
  },
  methods: {
    handleError() {
      this.error = true
      
      // Через 2 секунды убираем ошибку
      setTimeout(() => {
        this.error = false
      }, 2000)
    },

    showSlideCustom() {
      setTimeout(() => {
        this.showSlide = !this.showSlide
      }, 1000);
    },
    SvichLingRU() {
      if (!this.langStop) {
        this.lang = 'ru'
      }
    },
    SvichLingEN() {
      if (!this.langStop) {
        this.lang = 'en'
      }
    },
    ReturnText() {
      if (this.lang == 'ru') {
        return this.PageTextRu
      } else {
        return this.PageTextEn
      }
    },
    scrollTo(to) {
      if (to) {
        to.scrollIntoView({ behavior: 'smooth' });
      }
    },
    generateGUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    initializeDeviceId() {
      let storedDeviceId = localStorage.getItem("device_id");
      if (!storedDeviceId) {
        storedDeviceId = this.generateGUID();
        localStorage.setItem("device_id", storedDeviceId);
      }
      this.deviceId = storedDeviceId;
    },
    triggerFileInput() {
      this.error = false
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];

      if (!file) return;

      const maxSize = 25 * 1024 * 1024; // 25MB

      if (file.size > maxSize) {
        this.error = true;
        return;
      }

      this.error = false; // Сбрасываем ошибку, если файл подходит
      this.selectedFile = file;
      console.log(file);

      this.uploadFile();
    },
    async uploadFile() {
      this.load = true
      this.timer = 25000
      if (!this.selectedFile) {
        this.load = false
        this.error = true
        return;
      }
      this.stopTimer()
      this.timer = 25000, // Длительность в мс
        this.intervalId = null, // ID setInterval
        this.decreaseInterval = null, // ID setInterval для уменьшения таймера
        this.startTime = null, // Время старта
        this.elapsedTime = 0, // Сколько уже прошло времени
        this.isRunning = false, // Флаг для отслеживания состояния таймера
        this.count = 0
      const formData = new FormData();
      formData.append("language", this.lang);
      formData.append("file", this.selectedFile);
      formData.append("device_id", this.deviceId);

      try {
        const response = await fetch(this.ApiLink + "/api/upload", {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        console.log(result);

        if (response.ok) {
          this.load = false
          this.taskId = result.task_id; // Записываем task_id в data
          localStorage.setItem("task_id", result.task_id); // Сохраняем в localStorage
          console.log("Task ID сохранён:", this.taskId);
          this.currentSlide = 2
          this.startTimer()
          this.$refs.fileInput.value = "";
        }
        if (!response.ok) {
          this.load = false;
          this.error = true;
          this.$refs.fileInput.value = "";
        }
      }

      catch (error) {
        console.error("Ошибка загрузки:", error);
      }
    },
    async Ping() {
      try {
        const response = await fetch(this.ApiLink + '/tasks/' + this.taskId, {
          method: 'GET',
        });

        if (!response.ok) {
          this.error = true
          this.stopTimer()
          this.prevSlide()
          return;
        }
        else {
          const data = await response.json();
          console.log(data.status);

          if (data.status !== 'completed' && data.status !== 'error') {
            // Запускаем следующий запрос через 5 секунд, если статус не "completed"
            this.pingInterval = setTimeout(() => {
              this.increaseTimer();
            }, 4000);
          } else
            if (data.status === 'error') {
              this.decreaseTimerLoop()
              this.error = true
              this.stopTimer()
              this.prevSlide()
              return;
            }
            else {
              this.decreaseTimerLoop()
              this.link = process.env.VUE_APP_API_ROOT + data.link
            }
        }
      } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
      }
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    handleScrollBack() {
      // Вызываем твой существующий метод или его часть
      this.scrollBack();
    },
    
    scrollBack() {
      // Твоя логика скролла назад
      if (this.currentSlide === 1) {
        this.isAnimating = true;
        
        this.currentSlide = 0;

        setTimeout(() => {
          this.isAnimating = false;
        }, 1000);
      }
    },
    onWheel(event) {
      const scrollAmount = event.deltaY;
      if (this.currentSlide == 1) {
        this.isAnimating == true
      }
      if (this.isAnimating) {
        event.preventDefault(); // Если анимация идет, запрещаем скролл
        return;
      }

      if (this.currentSlide === 0 && scrollAmount > 0) {
        this.isAnimating = true;
        event.preventDefault(); // Блокируем скролл вниз

        this.$refs.chipsContainer.scrollLeft += scrollAmount;
        this.currentSlide = 1 // Запускаем анимацию

        setTimeout(() => {
          this.isAnimating = false;
        }, 1000);
      } else if (this.currentSlide === 1 && scrollAmount < 0) {
        // Проверяем, что страница доскролена до самого верха
        if (window.scrollY === 0) {
          this.isAnimating = true;
          
          event.preventDefault(); // Блокируем скролл вверх

          this.currentSlide = 0 // Запускаем анимацию назад

          setTimeout(() => {
            this.isAnimating = false;
          }, 1000);
        }
      }
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.SlideCount
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.SlideCount) % this.SlideCount;
      this.selectedFile = null
    },
    startCounter(target) {
      if (this.intervalId) clearInterval(this.intervalId); // Остановить предыдущий таймер

      this.startTime = performance.now() - this.elapsedTime; // Коррекция времени старта
      const stepTime = 16;
      this.isRunning = true; // Устанавливаем флаг, что таймер работает

      this.intervalId = setInterval(() => {
        const now = performance.now();
        this.elapsedTime = now - this.startTime;

        let progress = (this.elapsedTime / this.timer) * target;
        if (progress >= target) {
          progress = target;
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.isRunning = false; // Сбрасываем флаг, когда таймер завершился
        }
        this.count = Math.floor(progress);
      }, stepTime);
    },
    startTimer() {
      if (!this.isRunning) {
        this.startCounter(100);
      }
    },
    stopTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.isRunning = false;
    },
    restartCounter() {
      this.startTime = performance.now() - this.elapsedTime;
    },
    increaseTimer() {
      if (this.decreaseInterval) {
        clearInterval(this.decreaseInterval); // Останавливаем уменьшение
        this.decreaseInterval = null;
      }
      this.timer += 5000;
    },
    decreaseTimer() {
      if (this.timer > 1000 && this.count !== 100) {
        this.timer -= 5000;
      }
    },
    decreaseTimerLoop() {
      if (this.decreaseInterval) return; // Если уже запущен, не дублируем

      this.decreaseInterval = setInterval(() => {
        if (this.count !== 100 && this.timer > 1000) {
          this.timer -= 5000;
        } else {
          clearInterval(this.decreaseInterval); // Останавливаем, если count = 100
          this.decreaseInterval = null;
        }
      }, 1000);
    },
  },
  watch: {
    timer(newVal, oldVal) {
      if (this.isRunning) {
        this.restartCounter();
      }

    },
    count(newVal) {
      if (newVal === 100) {
        this.currentSlide = 3;
        this.timer = 25000
      }
    }
  },
  beforeMount() {
    console.log(window.location.hash);
    if (window.location.hash == '#/') {
      this.lang = 'ru'
    }else if (window.location.hash == '#/ru') {
      this.lang = 'ru'
    }
     else {
      this.lang = 'en'
    }
  }
}
</script>
<style scoped>
.back_arrow_v2 {
  position: absolute;
}

</style>